// extracted by mini-css-extract-plugin
module.exports = {"controls":"BottomControls_controls__1wXIb","controlsWrapper":"BottomControls_controlsWrapper__3jPXj","doubleBtns":"BottomControls_doubleBtns__2XUML"};